import { useTranslations } from 'next-intl';
import { ErrorMessage, ErrorMessageProps } from 'formik';

type ErrorMesseageTranslationProps = {
  translationKey: string;
  translationValues: Record<string, string | number>;
};

interface ErrorMessageTranslationProps extends ErrorMessageProps {
  className?: string;
}

const ErrorMesseageTranslation: React.FC<ErrorMessageTranslationProps> = ({
  className,
  ...props
}) => {
  const validationsTranslation = useTranslations('validations');

  return (
    <ErrorMessage
      {...props}
      render={(msg: string | ErrorMesseageTranslationProps) => {
        let translatedMsg = ''

        if (typeof msg === 'string') {
          translatedMsg = validationsTranslation.has(msg) ? validationsTranslation(msg) : msg;
        } else if (typeof msg === 'object' && msg.translationKey) {
          translatedMsg = validationsTranslation(msg.translationKey, msg.translationValues);
        }

        return <div className={className ?? 'invalid-feedback tw-block'}>{translatedMsg}</div>;
      }}
    />
  );
};

export default ErrorMesseageTranslation;
